import { AxiosInterceptor } from "api/core/consts";

export const stockPlace = {
  searchStockPlace: (body) => AxiosInterceptor.post('stockPlace/search', body),
  createStockPlace: (body) => AxiosInterceptor.post('stockPlace', body),
  updateStockPlace: (stockPlaceId, body) => AxiosInterceptor.put('stockPlace/' + stockPlaceId, body),
  deleteStockPlace: (stockPlaceId) => AxiosInterceptor.delete('stockPlace/' + stockPlaceId),
};
